
	export const cents_to_dollars:(price: number) => string = (price) => {
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD'
		});

		return formatter.format(price / 100.00);
	}